import { getDaysInMonth } from "date-fns";
import { DAYS } from "../../constants/options";

export const getListOfDaysInMonth = (month, year) => {
  const activeDays = [...DAYS];
  const maxDaysInMonth = 31;
  const daysInMonth = getDaysInMonth(new Date(year, month - 1));
  const deleteCount = maxDaysInMonth - daysInMonth;
  const start = maxDaysInMonth - deleteCount;
  
  activeDays.splice(start, deleteCount);
  
  return activeDays;
};

export const wipeValueIfDayLargerThanMonthsAllowed = (day, month, year, wipeValue) => {
  const daysInMonth = getDaysInMonth(new Date(year, month - 1));
  if (day && day * 1 > daysInMonth) {
    wipeValue();
  }
};

